import { conf } from '@convincely/utils/lib/services/conf.js';
import { paramsReplacer } from '@convincely/utils/lib/params.js';
import { urlParams } from '@convincely/utils/lib/url-params.js';
const isDevSplit = /-dev$/;
export function featureToggle(appName, featureKey = 'feature', feature = urlParams[featureKey] || conf[featureKey], urlTemplate = 'https://app.convincely.com/feature/:appName/:feature/', urlTemplateTest = 'https://app-test.convincely.com/:appName/:feature/') {
    const { featureToggles } = conf;
    if (feature) {
        if (feature === 'staging') {
            conf.baseUrl = paramsReplacer(urlTemplateTest, { appName, feature: 'integration' });
        }
        else if (featureToggles) {
            const [computedFeature, dev] = feature.split(isDevSplit);
            const isDev = dev === '';
            if (isDev) {
                feature = `feature/${feature}`;
            }
            if (computedFeature && featureToggles[computedFeature]) {
                conf.baseUrl = paramsReplacer(isDev ? urlTemplateTest : urlTemplate, { appName, feature });
            }
        }
    }
}
//# sourceMappingURL=feature-toggles.js.map